import { createSelector } from 'reselect';

import { DishwasherState } from './dishwasher.types';

import { RootState } from '~/redux/store';

export const selectBrowsedDishwashers = createSelector(
  [({ dishwasher }: RootState) => dishwasher.browsedDishwashersById],
  (browsedDishwashersById): DishwasherState['browsedDishwashersById'] =>
    Object.values(browsedDishwashersById)
);

export const selectSelectedDishwasherId = ({
  dishwasher,
}: RootState): DishwasherState['selectedDishwasherId'] =>
  dishwasher.selectedDishwasherId;

export const selectInStoreDishwashersUrl = ({
  dishwasher,
}: RootState): DishwasherState['inStoreDishwashersUrl'] =>
  dishwasher.inStoreDishwashersUrl;
